import {
  Info,
  Phone,
  HelpCircle,
  Truck,
  RotateCcw,
  Ruler,
  Gift,
  RefreshCw,
  BookOpen,
  Package,
  Shield,
  ScrollText,
  FileText,
  ShoppingCart,
  Store,
  type LucideIcon,
} from "lucide-react";

export interface SitePage {
  name: string;
  path: string;
  keywords: string[];
  icon: LucideIcon;
  description: string;
}

/** Static site pages exposed by the global search dialog. */
export const SITE_PAGES: SitePage[] = [
  { name: 'אודות', path: '/about', keywords: ['אודות', 'אודותינו', 'מי אנחנו', 'אליס', 'about'], icon: Info, description: 'קצת עלינו ועל החזון שלנו' },
  { name: 'צור קשר', path: '/contact', keywords: ['צור קשר', 'טלפון', 'כתובת', 'מייל', 'contact'], icon: Phone, description: 'דרכים ליצור איתנו קשר' },
  { name: 'שאלות נפוצות', path: '/faq', keywords: ['שאלות', 'תשובות', 'FAQ', 'שאלות נפוצות', 'עזרה'], icon: HelpCircle, description: 'תשובות לשאלות הנפוצות ביותר' },
  { name: 'משלוחים', path: '/shipping', keywords: ['משלוח', 'משלוחים', 'זמן אספקה', 'דואר', 'shipping'], icon: Truck, description: 'מידע על משלוחים וזמני אספקה' },
  { name: 'החזרות', path: '/returns', keywords: ['החזרה', 'החלפה', 'החזרות', 'ביטול', 'returns'], icon: RotateCcw, description: 'מדיניות החזרות והחלפות' },
  { name: 'מדריך מידות', path: '/ring-size-guide', keywords: ['מידה', 'טבעת', 'מידות', 'גודל', 'size guide'], icon: Ruler, description: 'מדריך למציאת המידה המתאימה' },
  { name: 'כרטיס מתנה', path: '/gift-card', keywords: ['מתנה', 'גיפט קארד', 'שובר', 'gift card', 'gift'], icon: Gift, description: 'רכישת כרטיס מתנה' },
  { name: 'Trade In', path: '/trade-in', keywords: ['טרייד אין', 'trade in', 'החלפה', 'מחזור', 'זהב ישן'], icon: RefreshCw, description: 'החלפת תכשיטים ישנים בחדשים' },
  { name: 'בלוג', path: '/blog', keywords: ['בלוג', 'מאמרים', 'כתבות', 'blog', 'טיפים'], icon: BookOpen, description: 'מאמרים וטיפים מעולם התכשיטים' },
  { name: 'מעקב הזמנה', path: '/track-order', keywords: ['מעקב', 'הזמנה', 'סטטוס', 'תיקון', 'track'], icon: Package, description: 'מעקב אחרי הזמנות ותיקונים' },
  { name: 'נגישות', path: '/accessibility', keywords: ['נגישות', 'accessibility'], icon: Shield, description: 'הצהרת נגישות' },
  { name: 'פרטיות', path: '/privacy', keywords: ['פרטיות', 'מדיניות', 'privacy'], icon: ScrollText, description: 'מדיניות פרטיות' },
  { name: 'תקנון', path: '/terms', keywords: ['תקנון', 'תנאי שימוש', 'terms'], icon: FileText, description: 'תנאי שימוש באתר' },
  { name: 'עגלת קניות', path: '/cart', keywords: ['עגלה', 'סל קניות', 'cart'], icon: ShoppingCart, description: 'עגלת הקניות שלך' },
  { name: 'החנות', path: '/shop', keywords: ['חנות', 'כל המוצרים', 'shop', 'מוצרים'], icon: Store, description: 'כל המוצרים שלנו' },
];

export function searchSitePages(query: string): SitePage[] {
  const q = query.trim().toLowerCase();
  if (q.length < 2) return [];
  return SITE_PAGES.filter((page) =>
    page.name.toLowerCase().includes(q) ||
    page.keywords.some((kw) => kw.toLowerCase().includes(q))
  );
}
